
import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import RewardFormLayout from './containers/Form';
import RewardsGridLayout from './containers/Grid';

export default function RewardLayout() {
  return <Router>
    <PrivateRoute exact path={["/cms/rewards", "/cms/rewards/add"]} component={RewardsGridLayout} />
    <PrivateRoute path="/cms/rewards/:id" component={RewardFormLayout} />
  </Router>
}

